






























import { Vue, Component, Prop, Ref } from 'vue-property-decorator'
import { QFile } from 'quasar'
import arrayCrdtSortNumber from 'src/assets/arrayCrdtSortNumber'
import DialogFullscreen from 'components/modals/Fullscreen.vue'
import icon from 'components/presenter/item/ItemIcon'
import FileInput from 'components/presenter/item/FileInput.vue'
import { Item } from 'src/graphql/types'

@Component({
  components: {
    DialogFullscreen,
    FileInput
  }
})
export default class ItemTopicInfoEditorImageForm extends Vue {
  icon = icon

  @Prop()
  readonly item!: Item

  @Ref()
  readonly dialog!: DialogFullscreen

  get src () {
    return this.item.data?.info?.coverImageUrl || ''
  }

  show () {
    this.dialog.show()
  }

  hide () {
    this.dialog.hide()
  }

  async infoImageSet (url: string) {
    const infoSettings: Json = {}
    infoSettings[`coverImageUrl`] = url || null
    await this.item.data?.save({ infoSettings })
  }
}
